import React from 'react';

import ReduxConnect from 'Demora/redux-connect';

import { Link } from 'react-router-dom';

class ProfileUnderProfileImage extends React.Component {
	render() {
		let props = this.props;

		let obj = props.obj;

		let u = props.users[obj];

		if (!u) {
			return null;
		}

		let cis = u.countrySelected;

		let cip = u.countryFromIp;

		if (!cip) {
			return null;
		}

		if (!cis) {
			cis = cip;
		}

		return (
			<div className='text-center small'>
				<div>
					<img
						style={{ width: '25px' }}
						src={'/assets/countries/' + cis.code.toLowerCase() + '.gif'}
						alt={cis.name}
						title={cis.name}
					/>
					{cis.code != cip.code && (
						<span>
							<br className='d-md-none' />
							&nbsp;(location{' '}
							<img
								style={{ width: '25px' }}
								src={'/assets/countries/' + cip.code.toLowerCase() + '.gif'}
								alt={cip.name}
								title={cip.name}
							/>
							)
						</span>
					)}
				</div>
				{obj.split('-')[0] == props.user.id && (
					<div className='small'>
						<Link to='/settings/editProfile'>Change</Link>
					</div>
				)}
			</div>
		);
	}
}

export default ReduxConnect(ProfileUnderProfileImage, {
	user: 'user',
	users: 'users',
});
